<div class="filter-container d-flex flex-column flex-lg-row align-items-lg-end justify-content-lg-between">
  <fgbcl-date-range-picker
    [(startDate)]="transactionStartDate"
    [(endDate)]="transactionEndDate"
  ></fgbcl-date-range-picker>
  <button
    type="button"
    class="search-button fw-bold border-0 text-white"
    (click)="splitTransaction.reset(); splitTransaction.search()"
    [disabled]="splitTransaction.loading$ | async"
  >
    {{ "transactions.search" | translate }}
  </button>
</div>

<div class="mt-4">
  <fgb-split-transaction-list
    [dateFrom]="transactionStartDate"
    [dateTo]="transactionEndDate"
    #splitTransaction
  ></fgb-split-transaction-list>
</div>
